module.exports = __webpack_public_path__ + "assets/img/prof_congrats.png";